import * as React from "react";
import {cx} from "emotion";

import "./field-line.scss";

import {cs}            from "@Common/react/chain-services";
import {keyed}         from "@Common/react/keyed";
import {scnv}          from "@Common/react/state-change-nested-value";
import {Static2}       from "@Common/react/static-2";
import {TimeoutAction} from "@Common/react/timeout-action";
import {UseState}      from "@Common/react/use-state";

import {Textarea5ew} from "./textarea-5ew";

export const FieldLine = ({label, maxLength, state, editable, grey=false}) => cs(
    ["typing", (_, next) => UseState({next})],
    ["doSave", ({typing}, next) => next(() => {
        scnv(state, [], () => typing.value);
        typing.onChange(null);
    })],
    ["domRef", (_, next) => Static2({next})],
    ({typing, doSave, domRef}) => (
        <div className={cx("field-line-2ii", {grey})}>
            <div {...{
                className: cx("label"),

                "xd-qa-type": "label",
                "xd-qa-name": label,
                onClick: () => {
                    domRef.get()?.select();
                },
            }}>
                {label}
            </div>

            {typing.value && cs(
                keyed(typing.value),
                () => TimeoutAction({
                    delay: 500,
                    action: doSave,
                })
            )}

            {Textarea5ew({
                editable,
                className: "textarea",
                state: state,
                xdQaName: label,
                maxLength,
                domRef,
            })}

        </div>
    ),
);
